import { SVGProps } from "react";

export const Icons = {
  Coffee: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M4 0C4.55228 0 5 0.447716 5 1V1.67157C5 1.93679 5.10536 2.19114 5.29289 2.37868L6.70711 3.79289C6.89464 3.98043 7 4.23478 7 4.5V6C7 6.55228 6.55228 7 6 7C5.44772 7 5 6.55228 5 6V5.32843C5 5.06321 4.89464 4.80886 4.70711 4.62132L3.29289 3.20711C3.10536 3.01957 3 2.76522 3 2.5V1C3 0.447715 3.44772 0 4 0Z"
          fill={props.fill || "#6366F1"}
        />
        <path
          d="M10 0C10.5523 0 11 0.447716 11 1V1.67157C11 1.93679 11.1054 2.19114 11.2929 2.37868L12.7071 3.79289C12.8946 3.98043 13 4.23478 13 4.5V6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6V5.32843C11 5.06321 10.8946 4.80886 10.7071 4.62132L9.29289 3.20711C9.10536 3.01957 9 2.76522 9 2.5V1C9 0.447715 9.44771 0 10 0Z"
          fill={props.fill || "#6366F1"}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 9C0 8.44772 0.447716 8 1 8H21C21.5523 8 22 8.44771 22 9V15C22 15.5523 21.5523 16 21 16H18C17.4477 16 17 16.4477 17 17V21C17 21.5523 16.5523 22 16 22H1C0.447715 22 0 21.5523 0 21V9ZM17 13C17 13.5523 17.4477 14 18 14H19C19.5523 14 20 13.5523 20 13V11C20 10.4477 19.5523 10 19 10H18C17.4477 10 17 10.4477 17 11V13ZM15 11C15 10.4477 14.5523 10 14 10H3C2.44772 10 2 10.4477 2 11V19C2 19.5523 2.44772 20 3 20H14C14.5523 20 15 19.5523 15 19V11Z"
          fill={props.fill || "#6366F1"}
        />
      </svg>
    );
  },
  Coin: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_843_27166)">
          <path
            d="M8.66665 15.3327C12.7168 15.3327 16 12.0495 16 7.99935C16 3.94926 12.7168 0.666016 8.66665 0.666016C4.61656 0.666016 1.33331 3.94926 1.33331 7.99935C1.33331 12.0495 4.61656 15.3327 8.66665 15.3327Z"
            fill="#F59E0B"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.66666 8C4.66666 5.79064 6.45729 4 8.66666 4C9.54736 4 10.3981 4.29044 11.0909 4.81828C10.739 4.71854 10.3722 4.66667 9.99999 4.66667C9.42007 4.66667 8.86899 4.79004 8.37157 5.01197C7.6836 5.07989 7.03664 5.38377 6.54353 5.87687C5.98044 6.43997 5.6641 7.20368 5.6641 8C5.6641 8.55365 5.81702 9.09153 6.09945 9.55719C6.31051 10.4857 6.84457 11.2914 7.57725 11.8499C5.89746 11.3756 4.66666 9.83171 4.66666 8ZM12.5657 7.10705C12.6323 7.39768 12.6667 7.69707 12.6667 8C12.6667 9.62944 11.6927 11.0311 10.2951 11.6547C10.1974 11.6643 10.099 11.6692 9.99999 11.6692C9.27486 11.6692 8.57676 11.4069 8.03257 10.9348C8.23936 10.9795 8.45182 11.0026 8.66666 11.0026C9.46298 11.0026 10.2267 10.6862 10.7898 10.1231C11.3529 9.56003 11.6692 8.79632 11.6692 8C11.6692 7.20368 11.3529 6.43997 10.7898 5.87687C10.7394 5.82653 10.6875 5.77817 10.6341 5.73182C11.1938 5.85276 11.7119 6.13237 12.1231 6.54354C12.294 6.71446 12.4422 6.90386 12.5657 7.10705Z"
            fill="#FCFCFC"
          />
        </g>
        <defs>
          <clipPath id="clip0_843_27166">
            <rect
              width="14.6667"
              height="14.6667"
              fill="white"
              transform="translate(1.33331 0.666016)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  },
  PCoin: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_843_27166)">
          <path
            d="M8.66665 15.3327C12.7168 15.3327 16 12.0495 16 7.99935C16 3.94926 12.7168 0.666016 8.66665 0.666016C4.61656 0.666016 1.33331 3.94926 1.33331 7.99935C1.33331 12.0495 4.61656 15.3327 8.66665 15.3327Z"
            fill="#F59E0B"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.66666 8C4.66666 5.79064 6.45729 4 8.66666 4C9.54736 4 10.3981 4.29044 11.0909 4.81828C10.739 4.71854 10.3722 4.66667 9.99999 4.66667C9.42007 4.66667 8.86899 4.79004 8.37157 5.01197C7.6836 5.07989 7.03664 5.38377 6.54353 5.87687C5.98044 6.43997 5.6641 7.20368 5.6641 8C5.6641 8.55365 5.81702 9.09153 6.09945 9.55719C6.31051 10.4857 6.84457 11.2914 7.57725 11.8499C5.89746 11.3756 4.66666 9.83171 4.66666 8ZM12.5657 7.10705C12.6323 7.39768 12.6667 7.69707 12.6667 8C12.6667 9.62944 11.6927 11.0311 10.2951 11.6547C10.1974 11.6643 10.099 11.6692 9.99999 11.6692C9.27486 11.6692 8.57676 11.4069 8.03257 10.9348C8.23936 10.9795 8.45182 11.0026 8.66666 11.0026C9.46298 11.0026 10.2267 10.6862 10.7898 10.1231C11.3529 9.56003 11.6692 8.79632 11.6692 8C11.6692 7.20368 11.3529 6.43997 10.7898 5.87687C10.7394 5.82653 10.6875 5.77817 10.6341 5.73182C11.1938 5.85276 11.7119 6.13237 12.1231 6.54354C12.294 6.71446 12.4422 6.90386 12.5657 7.10705Z"
            fill="#FCFCFC"
          />
        </g>
        <defs>
          <clipPath id="clip0_843_27166">
            <rect
              width="14.6667"
              height="14.6667"
              fill="white"
              transform="translate(1.33331 0.666016)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  },
  RCoin: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_843_27166)">
          <path
            d="M8.66665 15.3327C12.7168 15.3327 16 12.0495 16 7.99935C16 3.94926 12.7168 0.666016 8.66665 0.666016C4.61656 0.666016 1.33331 3.94926 1.33331 7.99935C1.33331 12.0495 4.61656 15.3327 8.66665 15.3327Z"
            fill="#10B981"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.66666 8C4.66666 5.79064 6.45729 4 8.66666 4C9.54736 4 10.3981 4.29044 11.0909 4.81828C10.739 4.71854 10.3722 4.66667 9.99999 4.66667C9.42007 4.66667 8.86899 4.79004 8.37157 5.01197C7.6836 5.07989 7.03664 5.38377 6.54353 5.87687C5.98044 6.43997 5.6641 7.20368 5.6641 8C5.6641 8.55365 5.81702 9.09153 6.09945 9.55719C6.31051 10.4857 6.84457 11.2914 7.57725 11.8499C5.89746 11.3756 4.66666 9.83171 4.66666 8ZM12.5657 7.10705C12.6323 7.39768 12.6667 7.69707 12.6667 8C12.6667 9.62944 11.6927 11.0311 10.2951 11.6547C10.1974 11.6643 10.099 11.6692 9.99999 11.6692C9.27486 11.6692 8.57676 11.4069 8.03257 10.9348C8.23936 10.9795 8.45182 11.0026 8.66666 11.0026C9.46298 11.0026 10.2267 10.6862 10.7898 10.1231C11.3529 9.56003 11.6692 8.79632 11.6692 8C11.6692 7.20368 11.3529 6.43997 10.7898 5.87687C10.7394 5.82653 10.6875 5.77817 10.6341 5.73182C11.1938 5.85276 11.7119 6.13237 12.1231 6.54354C12.294 6.71446 12.4422 6.90386 12.5657 7.10705Z"
            fill="#FCFCFC"
          />
        </g>
        <defs>
          <clipPath id="clip0_843_27166">
            <rect
              width="14.6667"
              height="14.6667"
              fill="white"
              transform="translate(1.33331 0.666016)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  },
  BCoin: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_843_27166)">
          <path
            d="M8.66665 15.3327C12.7168 15.3327 16 12.0495 16 7.99935C16 3.94926 12.7168 0.666016 8.66665 0.666016C4.61656 0.666016 1.33331 3.94926 1.33331 7.99935C1.33331 12.0495 4.61656 15.3327 8.66665 15.3327Z"
            fill="#e94e91ff"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.66666 8C4.66666 5.79064 6.45729 4 8.66666 4C9.54736 4 10.3981 4.29044 11.0909 4.81828C10.739 4.71854 10.3722 4.66667 9.99999 4.66667C9.42007 4.66667 8.86899 4.79004 8.37157 5.01197C7.6836 5.07989 7.03664 5.38377 6.54353 5.87687C5.98044 6.43997 5.6641 7.20368 5.6641 8C5.6641 8.55365 5.81702 9.09153 6.09945 9.55719C6.31051 10.4857 6.84457 11.2914 7.57725 11.8499C5.89746 11.3756 4.66666 9.83171 4.66666 8ZM12.5657 7.10705C12.6323 7.39768 12.6667 7.69707 12.6667 8C12.6667 9.62944 11.6927 11.0311 10.2951 11.6547C10.1974 11.6643 10.099 11.6692 9.99999 11.6692C9.27486 11.6692 8.57676 11.4069 8.03257 10.9348C8.23936 10.9795 8.45182 11.0026 8.66666 11.0026C9.46298 11.0026 10.2267 10.6862 10.7898 10.1231C11.3529 9.56003 11.6692 8.79632 11.6692 8C11.6692 7.20368 11.3529 6.43997 10.7898 5.87687C10.7394 5.82653 10.6875 5.77817 10.6341 5.73182C11.1938 5.85276 11.7119 6.13237 12.1231 6.54354C12.294 6.71446 12.4422 6.90386 12.5657 7.10705Z"
            fill="#FCFCFC"
          />
        </g>
        <defs>
          <clipPath id="clip0_843_27166">
            <rect
              width="14.6667"
              height="14.6667"
              fill="white"
              transform="translate(1.33331 0.666016)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  },
  WebCam: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.16669 18.3334H13.8334M17.5834 8.75008C17.5834 12.6621 14.412 15.8334 10.5 15.8334C6.588 15.8334 3.41669 12.6621 3.41669 8.75008C3.41669 4.83806 6.588 1.66675 10.5 1.66675C14.412 1.66675 17.5834 4.83806 17.5834 8.75008ZM13.1563 8.75008C13.1563 10.2171 11.967 11.4063 10.5 11.4063C9.03301 11.4063 7.84377 10.2171 7.84377 8.75008C7.84377 7.28308 9.03301 6.09383 10.5 6.09383C11.967 6.09383 13.1563 7.28308 13.1563 8.75008Z"
          stroke="#FCFCFC"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  RejectCall: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M17.9998 2.5L12.9998 7.5M12.9998 2.5L17.9998 7.5M9.02228 11.5526C8.02097 10.5512 7.23031 9.41904 6.65031 8.21102C6.60042 8.10712 6.57548 8.05516 6.55631 7.98942C6.48821 7.75579 6.53713 7.46891 6.67881 7.27105C6.71867 7.21537 6.7663 7.16774 6.86156 7.07248C7.1529 6.78115 7.29857 6.63548 7.39381 6.48899C7.75297 5.93659 7.75297 5.22443 7.39381 4.67203C7.29857 4.52554 7.1529 4.37988 6.86156 4.08854L6.69917 3.92615C6.2563 3.48328 6.03487 3.26184 5.79705 3.14156C5.32408 2.90233 4.76553 2.90233 4.29256 3.14156C4.05474 3.26184 3.83331 3.48328 3.39044 3.92615L3.25908 4.05751C2.81773 4.49886 2.59705 4.71954 2.42851 5.01956C2.24149 5.35249 2.10703 5.86956 2.10816 6.25141C2.10918 6.59554 2.17594 6.83072 2.30944 7.30109C3.02692 9.82892 4.38065 12.2142 6.37063 14.2042C8.36061 16.1942 10.7459 17.5479 13.2737 18.2654C13.7441 18.3989 13.9793 18.4657 14.3234 18.4667C14.7053 18.4678 15.2224 18.3333 15.5553 18.1463C15.8553 17.9778 16.076 17.7571 16.5173 17.3158L16.6487 17.1844C17.0916 16.7415 17.313 16.5201 17.4333 16.2823C17.6725 15.8093 17.6725 15.2508 17.4333 14.7778C17.313 14.54 17.0916 14.3185 16.6487 13.8757L16.4863 13.7133C16.195 13.4219 16.0493 13.2763 15.9028 13.181C15.3504 12.8219 14.6383 12.8219 14.0858 13.181C13.9394 13.2763 13.7937 13.4219 13.5024 13.7133C13.4071 13.8085 13.3595 13.8562 13.3038 13.896C13.1059 14.0377 12.819 14.0866 12.5854 14.0185C12.5197 13.9994 12.4677 13.9744 12.3638 13.9245C11.1558 13.3445 10.0236 12.5539 9.02228 11.5526Z"
          stroke="#FCFCFC"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  Calendar: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M19 9H1M14 1V5M6 1V5M5.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H5.8C4.11984 3 3.27976 3 2.63803 3.32698C2.07354 3.6146 1.6146 4.07354 1.32698 4.63803C1 5.27976 1 6.11984 1 7.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21Z"
          stroke="#111111"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  NewCalendar: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M17.5 9.58268V7.33268C17.5 5.93255 17.5 5.23249 17.2275 4.69771C16.9878 4.2273 16.6054 3.84485 16.135 3.60517C15.6002 3.33268 14.9001 3.33268 13.5 3.33268H6.5C5.09987 3.33268 4.3998 3.33268 3.86502 3.60517C3.39462 3.84485 3.01217 4.2273 2.77248 4.69771C2.5 5.23249 2.5 5.93255 2.5 7.33268V14.3327C2.5 15.7328 2.5 16.4329 2.77248 16.9677C3.01217 17.4381 3.39462 17.8205 3.86502 18.0602C4.3998 18.3327 5.09987 18.3327 6.5 18.3327H10.4167M17.5 8.33268H2.5M13.3333 1.66602V4.99935M6.66667 1.66602V4.99935M15 17.4993V12.4993M12.5 14.9993H17.5"
          stroke="#232323"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  Google: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_670_8667)">
          <path
            d="M23.7148 12.2245C23.7148 11.2413 23.635 10.5237 23.4623 9.77963H12.2344V14.2176H18.8249C18.6921 15.3205 17.9746 16.9815 16.3801 18.0976L16.3577 18.2461L19.9078 20.9963L20.1537 21.0209C22.4126 18.9347 23.7148 15.8653 23.7148 12.2245Z"
            fill="#4285F4"
          />
          <path
            d="M12.234 23.9176C15.4628 23.9176 18.1734 22.8545 20.1533 21.0209L16.3797 18.0976C15.3698 18.8018 14.0145 19.2934 12.234 19.2934C9.07158 19.2934 6.38751 17.2074 5.43072 14.324L5.29048 14.3359L1.59906 17.1927L1.55078 17.3269C3.51732 21.2334 7.55674 23.9176 12.234 23.9176Z"
            fill="#34A853"
          />
          <path
            d="M5.4309 14.324C5.17844 13.5799 5.03234 12.7826 5.03234 11.9588C5.03234 11.1349 5.17844 10.3377 5.41762 9.5936L5.41093 9.43513L1.67325 6.53241L1.55096 6.59058C0.740459 8.21168 0.275391 10.0321 0.275391 11.9588C0.275391 13.8855 0.740459 15.7058 1.55096 17.3269L5.4309 14.324Z"
            fill="#FBBC05"
          />
          <path
            d="M12.234 4.62403C14.4795 4.62403 15.9943 5.59402 16.858 6.40461L20.233 3.10928C18.1602 1.1826 15.4628 0 12.234 0C7.55674 0 3.51732 2.68406 1.55078 6.59056L5.41744 9.59359C6.38751 6.7102 9.07157 4.62403 12.234 4.62403Z"
            fill="#EB4335"
          />
        </g>
        <defs>
          <clipPath id="clip0_670_8667">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
  Facebook: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clip-path="url(#clip0_1214_38303)">
          <path
            d="M32 16.001C32 7.16445 24.8366 0.0010128 16 0.0010128C7.16344 0.0010128 0 7.16445 0 16.001C0 23.9871 5.85097 30.6063 13.5 31.8066V20.626H9.4375V16.001H13.5V12.476C13.5 8.46601 15.8887 6.25101 19.5434 6.25101C21.294 6.25101 23.125 6.56351 23.125 6.56351V10.501H21.1074C19.1198 10.501 18.5 11.7344 18.5 12.9997V16.001H22.9375L22.2281 20.626H18.5V31.8066C26.149 30.6063 32 23.9871 32 16.001Z"
            fill="#1877F2"
          />
          <path
            d="M22.2281 20.625L22.9375 16H18.5V12.9987C18.5 11.7333 19.1198 10.5 21.1074 10.5H23.125V6.5625C23.125 6.5625 21.294 6.25 19.5434 6.25C15.8887 6.25 13.5 8.465 13.5 12.475V16H9.4375V20.625H13.5V31.8056C14.3146 31.9334 15.1495 32 16 32C16.8505 32 17.6854 31.9334 18.5 31.8056V20.625H22.2281Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1214_38303">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
  Instagram: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clip-path="url(#clip0_1214_38317)">
          <path
            d="M26.4288 7.45111C26.4288 6.38894 25.5679 5.53125 24.5097 5.53125C23.4514 5.53125 22.5898 6.38894 22.5898 7.45111C22.5898 8.50939 23.4514 9.36704 24.5097 9.36704C25.5679 9.36704 26.4288 8.50939 26.4288 7.45111Z"
            fill="url(#paint0_linear_1214_38317)"
          />
          <path
            d="M28.9858 22.4365C28.9148 23.9947 28.6541 24.8413 28.4378 25.4036C28.1471 26.1491 27.8004 26.6822 27.2382 27.2413C26.6822 27.8005 26.1491 28.1464 25.4036 28.4338C24.8413 28.6534 23.9915 28.9148 22.4334 28.989C20.7489 29.0633 20.2498 29.0791 15.9781 29.0791C11.7103 29.0791 11.2072 29.0633 9.5227 28.989C7.96458 28.9148 7.11874 28.6534 6.5564 28.4338C5.80696 28.1464 5.27786 27.8005 4.71872 27.2413C4.15562 26.6822 3.80894 26.1491 3.52226 25.4036C3.30583 24.8413 3.04131 23.9947 2.97414 22.4365C2.89205 20.752 2.87701 20.245 2.87701 15.982C2.87701 11.7103 2.89205 11.2072 2.97414 9.52266C3.04131 7.96455 3.30583 7.11876 3.52226 6.55169C3.80894 5.80697 4.15562 5.27703 4.71872 4.71789C5.27786 4.15959 5.80696 3.81285 6.5564 3.52227C7.11874 3.30193 7.96458 3.04446 9.5227 2.97024C11.2072 2.89596 11.7103 2.87701 15.9781 2.87701C20.2498 2.87701 20.7489 2.89596 22.4334 2.97024C23.9915 3.04446 24.8413 3.30193 25.4036 3.52227C26.1491 3.81285 26.6822 4.15959 27.2382 4.71789C27.8004 5.27703 28.1471 5.80697 28.4378 6.55169C28.6541 7.11876 28.9148 7.96455 28.9858 9.52266C29.064 11.2072 29.083 11.7103 29.083 15.982C29.083 20.245 29.064 20.752 28.9858 22.4365ZM31.8629 9.3916C31.7847 7.68889 31.5162 6.52562 31.1174 5.51241C30.7115 4.46125 30.1673 3.57042 29.2765 2.67959C28.3896 1.79273 27.4988 1.24858 26.4476 0.837936C25.4305 0.443047 24.2711 0.171355 22.5676 0.0971393C20.8641 0.0149862 20.3201 0 15.9781 0C11.64 0 11.092 0.0149862 9.38846 0.0971393C7.68893 0.171355 6.53034 0.443047 5.50845 0.837936C4.46125 1.24858 3.57042 1.79273 2.68356 2.67959C1.79273 3.57042 1.24858 4.46125 0.838706 5.51241C0.443815 6.52562 0.175322 7.68889 0.0931697 9.3916C0.0189538 11.0951 0 11.64 0 15.982C0 20.3201 0.0189538 20.8641 0.0931697 22.5676C0.175322 24.2672 0.443815 25.4297 0.838706 26.4477C1.24858 27.4949 1.79273 28.3897 2.68356 29.2765C3.57042 30.1634 4.46125 30.7115 5.50845 31.1213C6.53034 31.5162 7.68893 31.7847 9.38846 31.8629C11.092 31.9411 11.64 31.9601 15.9781 31.9601C20.3201 31.9601 20.8641 31.9411 22.5676 31.8629C24.2711 31.7847 25.4305 31.5162 26.4476 31.1213C27.4988 30.7115 28.3896 30.1634 29.2765 29.2765C30.1673 28.3897 30.7115 27.4949 31.1174 26.4477C31.5162 25.4297 31.7847 24.2672 31.8629 22.5676C31.9411 20.8641 31.96 20.3201 31.96 15.982C31.96 11.64 31.9411 11.0951 31.8629 9.3916Z"
            fill="url(#paint1_linear_1214_38317)"
          />
          <path
            d="M15.9784 21.3045C13.0382 21.3045 10.6524 18.9226 10.6524 15.9824C10.6524 13.0374 13.0382 10.6524 15.9784 10.6524C18.9195 10.6524 21.3084 13.0374 21.3084 15.9824C21.3084 18.9226 18.9195 21.3045 15.9784 21.3045ZM15.9784 7.77148C11.4461 7.77148 7.77539 11.45 7.77539 15.9824C7.77539 20.5108 11.4461 24.1854 15.9784 24.1854C20.5107 24.1854 24.1854 20.5108 24.1854 15.9824C24.1854 11.45 20.5107 7.77148 15.9784 7.77148Z"
            fill="url(#paint2_linear_1214_38317)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1214_38317"
            x1="0.288376"
            y1="31.6303"
            x2="29.2982"
            y2="2.62055"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFD521" />
            <stop offset="0.05" stop-color="#FFD521" />
            <stop offset="0.501119" stop-color="#F50000" />
            <stop offset="0.95" stop-color="#B900B4" />
            <stop offset="0.950079" stop-color="#B900B4" />
            <stop offset="1" stop-color="#B900B4" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1214_38317"
            x1="0.288275"
            y1="31.6694"
            x2="29.3219"
            y2="2.63577"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFD521" />
            <stop offset="0.05" stop-color="#FFD521" />
            <stop offset="0.501119" stop-color="#F50000" />
            <stop offset="0.95" stop-color="#B900B4" />
            <stop offset="0.950079" stop-color="#B900B4" />
            <stop offset="1" stop-color="#B900B4" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_1214_38317"
            x1="0.296178"
            y1="31.6706"
            x2="29.3228"
            y2="2.64392"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFD521" />
            <stop offset="0.05" stop-color="#FFD521" />
            <stop offset="0.501119" stop-color="#F50000" />
            <stop offset="0.95" stop-color="#B900B4" />
            <stop offset="0.950079" stop-color="#B900B4" />
            <stop offset="1" stop-color="#B900B4" />
          </linearGradient>
          <clipPath id="clip0_1214_38317">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
  Tiktok: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12.873 12.6321V11.3531C12.4379 11.2902 12.0029 11.264 11.5626 11.2588C6.21088 11.2588 1.86035 15.6093 1.86035 20.961C1.86035 24.1269 3.40663 27.0937 6.00122 28.9073C4.38681 27.1723 3.42759 24.8503 3.42759 22.2976C3.42235 17.0403 7.62088 12.7422 12.873 12.6321Z"
          fill="#25F4EE"
        />
        <path
          d="M13.1036 26.7636C15.4885 26.7636 17.4698 24.8347 17.5589 22.4655L17.5642 1.36806L21.3905 1.33661C21.3067 0.896314 21.2647 0.445536 21.2647 0H15.9969L15.9864 21.1289C15.9026 23.5715 13.8531 25.4794 11.4158 25.3956C10.7501 25.3746 10.1001 25.2016 9.50781 24.8871C10.315 25.9984 11.6202 26.7636 13.1036 26.7636Z"
          fill="#25F4EE"
        />
        <path
          d="M28.6025 8.54421V7.3334C27.182 7.3334 25.793 6.91931 24.6084 6.14355C25.6358 7.32292 27.0248 8.20351 28.6025 8.54421Z"
          fill="#25F4EE"
        />
        <path
          d="M24.609 6.14285C23.4453 4.81148 22.8059 3.10272 22.8059 1.33105H21.3906C21.7628 3.30714 22.9264 5.04735 24.609 6.14285Z"
          fill="#FE2C55"
        />
        <path
          d="M11.5623 16.5269C9.1145 16.5217 7.12793 18.503 7.12793 20.9508C7.12793 22.6019 8.04521 24.122 9.50762 24.882C8.07666 22.9007 8.5222 20.1384 10.4983 18.7022C11.2531 18.157 12.1651 17.8635 13.0981 17.8635C13.5437 17.8635 13.9839 17.9317 14.4085 18.0679V12.6901C13.9735 12.6272 13.5384 12.5957 13.0981 12.5957C13.0195 12.5957 12.9461 12.6009 12.8675 12.6009V16.7366C12.4482 16.6003 12.0079 16.5269 11.5623 16.5269Z"
          fill="#FE2C55"
        />
        <path
          d="M28.6034 8.50684V12.6058C25.9721 12.611 23.4037 11.7828 21.2704 10.247V20.9609C21.2704 26.3126 16.9146 30.6631 11.5682 30.6631C9.57637 30.6631 7.63698 30.0498 6.00684 28.9019C7.83616 30.878 10.4098 31.9997 13.104 31.9997C18.4556 31.9997 22.8062 27.6492 22.8062 22.2975V11.5837C24.9448 13.1194 27.5079 13.9476 30.1392 13.9424V8.66933C29.6255 8.66933 29.1118 8.61167 28.6034 8.50684Z"
          fill="#FE2C55"
        />
        <path
          d="M21.27 20.9609V10.247C23.4086 11.7828 25.9717 12.611 28.603 12.6057V8.50681C27.0515 8.17135 25.6467 7.34318 24.6089 6.14285C22.9263 5.04735 21.7627 3.30714 21.3906 1.33105H17.5327L17.5275 22.4652C17.4436 24.9078 15.3942 26.8157 12.9516 26.7319C11.5783 26.6847 10.3098 26.0033 9.51308 24.8868C7.34305 23.7546 6.5044 21.0762 7.63658 18.9114C8.40186 17.449 9.91668 16.5265 11.5678 16.5317C12.0133 16.5317 12.4536 16.5999 12.8782 16.7361V12.6005C7.63134 12.7211 3.40137 17.0244 3.40137 22.2975C3.40137 24.7505 4.32913 27.1145 6.00645 28.9071C7.63658 30.055 9.57598 30.6683 11.5678 30.6683C16.9142 30.6631 21.27 26.3125 21.27 20.9609Z"
          fill="black"
        />
      </svg>
    );
  },
  Youtube: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M31.3313 8.24755C30.9633 6.86173 29.8791 5.77046 28.5022 5.4001C26.0067 4.72701 16 4.72701 16 4.72701C16 4.72701 5.99333 4.72701 3.4978 5.4001C2.12102 5.77046 1.03665 6.86173 0.668678 8.24755C0 10.7592 0 15.9997 0 15.9997C0 15.9997 0 21.2402 0.668678 23.7521C1.03665 25.1377 2.12102 26.229 3.4978 26.5995C5.99333 27.2725 16 27.2725 16 27.2725C16 27.2725 26.0067 27.2725 28.5022 26.5995C29.8791 26.229 30.9633 25.1377 31.3313 23.7521C32 21.2402 32 15.9997 32 15.9997C32 15.9997 32 10.7592 31.3313 8.24755Z"
          fill="#ED1D24"
        />
        <path
          d="M12.7275 20.7578L21.0912 16.0001L12.7275 11.2419V20.7578Z"
          fill="white"
        />
      </svg>
    );
  },
  ShareIcon: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M17.5 5H14.8333C13.4332 5 12.7331 5 12.1984 5.27248C11.728 5.51217 11.3455 5.89462 11.1058 6.36502C10.8333 6.8998 10.8333 7.59987 10.8333 9V10M17.5 5L15 2.5M17.5 5L15 7.5M8.33333 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V13.5C2.5 14.9001 2.5 15.6002 2.77248 16.135C3.01217 16.6054 3.39462 16.9878 3.86502 17.2275C4.3998 17.5 5.09987 17.5 6.5 17.5H13.5C14.9001 17.5 15.6002 17.5 16.135 17.2275C16.6054 16.9878 16.9878 16.6054 17.2275 16.135C17.5 15.6002 17.5 14.9001 17.5 13.5V11.6667"
          stroke="#111111"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  HeartIcon: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M10.7414 2C13.0895 2 14.6673 4.235 14.6673 6.32C14.6673 10.5425 8.11917 14 8.00065 14C7.88213 14 1.33398 10.5425 1.33398 6.32C1.33398 4.235 2.91176 2 5.25991 2C6.60806 2 7.48954 2.6825 8.00065 3.2825C8.51176 2.6825 9.39325 2 10.7414 2Z"
          fill="#EF4444"
        />
      </svg>
    );
  },
  SpadeIcon: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M13.8884 6.37488C13.3569 5.47651 12.2316 4.36941 10.5436 3.08418C9.88451 2.58243 9.27769 2.16049 8.88456 1.89486C8.12108 1.37891 8.09883 1.37891 8.00506 1.37891C7.91153 1.37891 7.88934 1.37891 7.12615 1.89213C6.73279 2.15676 6.12531 2.57717 5.46584 3.07768C3.77577 4.36024 2.6472 5.46958 2.11167 6.37482C1.56655 7.2962 1.33398 8.14778 1.33398 9.22239C1.33398 11.9451 3.34081 13.1852 5.20541 13.1852C6.02332 13.1852 6.63931 12.9784 7.09995 12.6952L6.59003 14.6246H9.39092L8.87574 12.6754C9.33886 12.9687 9.96331 13.1852 10.7986 13.1852C12.6619 13.1852 14.6673 11.9451 14.6673 9.22239C14.6673 8.14937 14.4344 7.2978 13.8884 6.37488Z"
          fill="#090909"
        />
      </svg>
    );
  },
  DiamondIcon: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8.32371 1.214C8.16411 0.991814 7.83355 0.991813 7.67395 1.214L2.96645 7.76767C2.86628 7.90712 2.86628 8.09494 2.96645 8.23439L7.67395 14.7881C7.83355 15.0102 8.16411 15.0102 8.32371 14.7881L13.0312 8.23439C13.1314 8.09494 13.1314 7.90712 13.0312 7.76767L8.32371 1.214Z"
          fill="#EF4444"
        />
      </svg>
    );
  },
  CloverIcon: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11.129 5.93278C10.9491 5.93278 10.7727 5.94821 10.6007 5.97603C11.0202 5.42623 11.2702 4.74044 11.2702 3.99691C11.2702 2.19373 9.80301 0.726562 7.99985 0.726562C6.19644 0.726562 4.72928 2.19373 4.72928 3.99691C4.72928 4.74041 4.97909 5.4262 5.39848 5.97603C5.22652 5.94824 5.0501 5.93278 4.87041 5.93278C3.06677 5.93278 1.59961 7.40017 1.59961 9.20313C1.59961 11.0068 3.06677 12.4734 4.87041 12.4734C5.87818 12.4734 6.7806 12.0148 7.38086 11.2953C7.27806 12.7333 7.05325 14.1051 6.6287 15.2743H9.3705C8.94617 14.1051 8.72113 12.7333 8.61836 11.2953C9.21863 12.0148 10.121 12.4734 11.129 12.4734C12.9325 12.4734 14.3996 11.0067 14.3996 9.20313C14.3996 7.40017 12.9324 5.93278 11.129 5.93278Z"
          fill="#090909"
        />
      </svg>
    );
  },
  CheckVerifiedIcon: (props: SVGProps<SVGSVGElement>) => {
    // expert icon
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M6.00065 7.9987L7.33399 9.33203L10.334 6.33203M6.13525 13.7326C6.35375 13.7037 6.57448 13.763 6.74853 13.8971L7.55069 14.5126C7.81585 14.7163 8.18471 14.7163 8.44913 14.5126L9.28166 13.8734C9.4372 13.7541 9.63348 13.7015 9.82754 13.7274L10.8689 13.8645C11.2 13.9082 11.5192 13.7237 11.6474 13.4148L12.0481 12.446C12.1229 12.2645 12.2666 12.1208 12.4481 12.046L13.4169 11.6453C13.7257 11.5179 13.9102 11.1979 13.8665 10.8668L13.7346 9.86309C13.7057 9.64458 13.765 9.42385 13.8991 9.24978L14.5146 8.44758C14.7182 8.1824 14.7182 7.81352 14.5146 7.54908L13.8753 6.71651C13.7561 6.56096 13.7035 6.36467 13.7294 6.1706L13.8665 5.12915C13.9102 4.79805 13.7257 4.4788 13.4169 4.35065L12.4481 3.94992C12.2666 3.87511 12.1229 3.73141 12.0481 3.54993L11.6474 2.58107C11.52 2.27219 11.2 2.08775 10.8689 2.13145L9.82754 2.26849C9.63348 2.29515 9.4372 2.24256 9.2824 2.12405L8.44988 1.4848C8.18471 1.28111 7.81585 1.28111 7.55143 1.4848L6.71891 2.12405C6.56337 2.24256 6.36708 2.29515 6.17303 2.26997L5.13163 2.13293C4.80055 2.08923 4.48132 2.27367 4.35318 2.58255L3.95321 3.55141C3.87766 3.73215 3.73397 3.87585 3.55324 3.9514L2.58444 4.35139C2.27557 4.47954 2.09114 4.79879 2.13484 5.12989L2.27187 6.17134C2.29705 6.36541 2.24446 6.5617 2.12596 6.71651L1.48675 7.54908C1.28306 7.81426 1.28306 8.18314 1.48675 8.44758L2.12596 9.28015C2.2452 9.4357 2.29779 9.63199 2.27187 9.82606L2.13484 10.8675C2.09114 11.1986 2.27557 11.5179 2.58444 11.646L3.55324 12.0467C3.73471 12.1215 3.8784 12.2652 3.95321 12.4467L4.35392 13.4156C4.48132 13.7245 4.80129 13.9089 5.13237 13.8652L6.13525 13.7326Z"
          stroke="#111111"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  DoubleHeartIcon: (props: SVGProps<SVGSVGElement>) => {
    // beginner icon
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M10.3643 6.61565C10.6136 6.17272 10.8215 5.77304 10.9497 5.46884C11.5722 3.99168 10.9567 2.29254 9.45194 1.59945C7.94723 0.90635 6.43626 1.62503 5.77313 3.01265C4.50503 2.1425 2.81344 2.27029 1.88058 3.62819C0.947713 4.98609 1.24049 6.76005 2.51818 7.72806C3.09805 8.16739 4.24489 8.81483 5.32462 9.391M10.8654 7.832C10.5841 6.32003 9.29756 5.21426 7.67774 5.5148C6.05793 5.81535 5.01057 7.27675 5.22955 8.8647C5.40548 10.1405 6.3766 13.1338 6.75159 14.2614C6.80276 14.4152 6.82835 14.4922 6.879 14.5458C6.92313 14.5925 6.98181 14.6264 7.04435 14.6413C7.11613 14.6583 7.19555 14.642 7.35438 14.6094C8.51833 14.3704 11.5962 13.7147 12.789 13.2292C14.2737 12.6248 15.0399 10.9881 14.466 9.43403C13.8921 7.87994 12.3155 7.31971 10.8654 7.832Z"
          stroke={props?.stroke ?? "#111111"}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  CertificateIcon: (props: SVGProps<SVGSVGElement>) => {
    // certificate icon
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M6 12.332H10M4.66667 9.9987H11.3333M3.33333 1.33203H12.6667C13.403 1.33203 14 1.99531 14 2.81351V13.1839C14 14.0021 13.403 14.6654 12.6667 14.6654H3.33333C2.59695 14.6654 2 14.0021 2 13.1839V2.81351C2 1.99531 2.59695 1.33203 3.33333 1.33203ZM7.9984 4.13999C7.53189 3.62057 6.75394 3.48084 6.16943 3.95648C5.58492 4.43212 5.50263 5.22736 5.96165 5.7899C6.42067 6.35244 7.9984 7.66537 7.9984 7.66537C7.9984 7.66537 9.57614 6.35244 10.0352 5.7899C10.4942 5.22736 10.4219 4.42711 9.82738 3.95648C9.23282 3.48584 8.46492 3.62057 7.9984 4.13999Z"
          stroke={props?.stroke ?? "#111111"}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  StarIcon: (props: SVGProps<SVGSVGElement>) => {
    // star level icon
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M6 12.332H10M4.66667 9.9987H11.3333M3.33333 1.33203H12.6667C13.403 1.33203 14 1.99531 14 2.81351V13.1839C14 14.0021 13.403 14.6654 12.6667 14.6654H3.33333C2.59695 14.6654 2 14.0021 2 13.1839V2.81351C2 1.99531 2.59695 1.33203 3.33333 1.33203ZM7.9984 4.13999C7.53189 3.62057 6.75394 3.48084 6.16943 3.95648C5.58492 4.43212 5.50263 5.22736 5.96165 5.7899C6.42067 6.35244 7.9984 7.66537 7.9984 7.66537C7.9984 7.66537 9.57614 6.35244 10.0352 5.7899C10.4942 5.22736 10.4219 4.42711 9.82738 3.95648C9.23282 3.48584 8.46492 3.62057 7.9984 4.13999Z"
          stroke="#111111"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  SuperStarIcon: (props: SVGProps<SVGSVGElement>) => {
    // super star icon
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M3.00065 14.6654V11.332M3.00065 4.66537V1.33203M1.33398 2.9987H4.66732M1.33398 12.9987H4.66732M8.66732 1.9987L7.5112 5.00461C7.32319 5.49343 7.22919 5.73784 7.08301 5.94342C6.95345 6.12563 6.79425 6.28483 6.61204 6.41439C6.40646 6.56057 6.16205 6.65457 5.67323 6.84258L2.66732 7.9987L5.67323 9.15482C6.16205 9.34283 6.40646 9.43683 6.61204 9.58301C6.79425 9.71257 6.95345 9.87177 7.08301 10.054C7.22919 10.2596 7.32319 10.504 7.5112 10.9928L8.66732 13.9987L9.82344 10.9928C10.0114 10.504 10.1055 10.2596 10.2516 10.054C10.3812 9.87177 10.5404 9.71257 10.7226 9.58301C10.9282 9.43683 11.1726 9.34283 11.6614 9.15482L14.6673 7.9987L11.6614 6.84258C11.1726 6.65457 10.9282 6.56057 10.7226 6.41439C10.5404 6.28483 10.3812 6.12563 10.2516 5.94342C10.1055 5.73784 10.0114 5.49343 9.82344 5.00461L8.66732 1.9987Z"
          stroke="#111111"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  LanguageIcon: (props: SVGProps<SVGSVGElement>) => {
    // super star icon
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8.60935 11.3333H13.392M8.60935 11.3333L7.33399 14M8.60935 11.3333L10.5195 7.33935C10.6734 7.01752 10.7504 6.8566 10.8557 6.80575C10.9473 6.76152 11.054 6.76152 11.1456 6.80575C11.2509 6.8566 11.3279 7.01752 11.4818 7.33935L13.392 11.3333M13.392 11.3333L14.6673 14M1.33398 3.33333H5.33399M5.33399 3.33333H7.66732M5.33399 3.33333V2M7.66732 3.33333H9.33399M7.66732 3.33333C7.33656 5.30486 6.56904 7.09079 5.44435 8.58962M6.66732 9.33334C6.25897 9.14987 5.84242 8.89472 5.44435 8.58962M5.44435 8.58962C4.54267 7.89851 3.73583 6.95109 3.33398 6M5.44435 8.58962C4.37456 10.0153 2.98161 11.1812 1.33398 12"
          stroke="#111111"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  RocketIcon: (props: SVGProps<SVGSVGElement>) => {
    // rocket icon
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12 15.0002L9 12.0002M12 15.0002C13.3968 14.469 14.7369 13.799 16 13.0002M12 15.0002V20.0002C12 20.0002 15.03 19.4502 16 18.0002C17.08 16.3802 16 13.0002 16 13.0002M9 12.0002C9.53214 10.6197 10.2022 9.29631 11 8.05025C12.1652 6.18723 13.7876 4.6533 15.713 3.59434C17.6384 2.53538 19.8027 1.98662 22 2.00025C22 4.72025 21.22 9.50025 16 13.0002M9 12.0002H4C4 12.0002 4.55 8.97025 6 8.00025C7.62 6.92025 11 8.00025 11 8.00025M4.5 16.5002C3 17.7602 2.5 21.5002 2.5 21.5002C2.5 21.5002 6.24 21.0002 7.5 19.5002C8.21 18.6602 8.2 17.3702 7.41 16.5902C7.02131 16.2193 6.50929 16.0049 5.97223 15.9883C5.43516 15.9717 4.91088 16.154 4.5 16.5002Z"
          stroke="#111111"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  TalentIcon: (props: SVGProps<SVGSVGElement>) => {
    // talent icon
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M16 18L18 20L22 16M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
          stroke="#111111"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  Rating: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
      >
        <path
          d="M7.52144 2.30107C7.6751 1.98978 7.75193 1.83413 7.85623 1.7844C7.94697 1.74114 8.0524 1.74114 8.14315 1.7844C8.24745 1.83413 8.32427 1.98978 8.47793 2.30107L9.93572 5.25438C9.98108 5.34628 10.0038 5.39224 10.0369 5.42791C10.0663 5.4595 10.1015 5.48509 10.1406 5.50328C10.1847 5.52381 10.2354 5.53122 10.3368 5.54604L13.5977 6.02267C13.9411 6.07286 14.1127 6.09795 14.1922 6.18182C14.2613 6.25479 14.2938 6.35506 14.2807 6.45471C14.2656 6.56925 14.1413 6.69032 13.8927 6.93245L11.534 9.22981C11.4604 9.30142 11.4237 9.33723 11.4 9.37984C11.379 9.41756 11.3655 9.459 11.3603 9.50187C11.3544 9.55028 11.3631 9.60086 11.3804 9.70202L11.937 12.9469C11.9957 13.2892 12.025 13.4603 11.9699 13.5619C11.9219 13.6502 11.8366 13.7122 11.7377 13.7305C11.6241 13.7516 11.4704 13.6708 11.1631 13.5091L8.24793 11.9761C8.1571 11.9283 8.11168 11.9044 8.06384 11.8951C8.02147 11.8867 7.9779 11.8867 7.93554 11.8951C7.88769 11.9044 7.84228 11.9283 7.75145 11.9761L4.83629 13.5091C4.52895 13.6708 4.37528 13.7516 4.26166 13.7305C4.1628 13.7122 4.07749 13.6502 4.0295 13.5619C3.97434 13.4603 4.00369 13.2892 4.06239 12.9469L4.61893 9.70202C4.63628 9.60086 4.64496 9.55028 4.63909 9.50187C4.63389 9.459 4.62042 9.41756 4.59941 9.37984C4.57569 9.33723 4.53893 9.30142 4.4654 9.22981L2.10671 6.93245C1.85812 6.69031 1.73382 6.56925 1.71869 6.45471C1.70553 6.35506 1.73804 6.25479 1.80717 6.18182C1.88663 6.09795 2.05832 6.07286 2.4017 6.02267L5.66255 5.54604C5.76396 5.53122 5.81466 5.52381 5.85882 5.50328C5.89792 5.48509 5.93312 5.4595 5.96247 5.42791C5.99561 5.39224 6.01829 5.34628 6.06366 5.25438L7.52144 2.30107Z"
          fill="#6366F1"
          stroke="#6366F1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  Spade: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
      >
        <path
          d="M20.8316 9.55987C20.0344 8.21232 18.3464 6.55168 15.8144 4.62383C14.8258 3.87121 13.9156 3.2383 13.3259 2.83984C12.1806 2.06592 12.1473 2.06592 12.0066 2.06592C11.8663 2.06592 11.833 2.06592 10.6883 2.83576C10.0982 3.23271 9.18699 3.86331 8.19778 4.61407C5.66267 6.53792 3.96982 8.20193 3.16652 9.55978C2.34885 10.9419 2 12.2192 2 13.8311C2 17.9153 5.01024 19.7754 7.80714 19.7754C9.034 19.7754 9.95799 19.4652 10.6489 19.0403L9.88407 21.9345H14.0854L13.3126 19.0106C14.0073 19.4507 14.944 19.7754 16.1969 19.7754C18.9918 19.7754 22 17.9153 22 13.8311C22 12.2216 21.6506 10.9443 20.8316 9.55987Z"
          fill="var(--neutralWhite)"
        />
      </svg>
    );
  },
  Heart: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        {...props}
      >
        <path
          d="M14.1111 0C17.6333 0 20 3.3525 20 6.48C20 12.8138 10.1778 18 10 18C9.82222 18 0 12.8138 0 6.48C0 3.3525 2.36667 0 5.88889 0C7.91111 0 9.23333 1.02375 10 1.92375C10.7667 1.02375 12.0889 0 14.1111 0Z"
          fill="var(--neutralWhite)"
        />
      </svg>
    );
  },
  Diamond: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
      >
        <path
          d="M12.4873 1.81905C12.2479 1.48577 11.752 1.48577 11.5126 1.81905L4.45138 11.6495C4.30113 11.8587 4.30113 12.1404 4.45138 12.3496L11.5126 22.1801C11.752 22.5134 12.2479 22.5134 12.4873 22.1801L19.5485 12.3496C19.6988 12.1405 19.6988 11.8587 19.5485 11.6495L12.4873 1.81905Z"
          fill="var(--neutralWhite)"
        />
      </svg>
    );
  },
  Clover: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
      >
        <path
          d="M16.694 8.89868C16.4242 8.89868 16.1596 8.92183 15.9016 8.96355C16.5307 8.13885 16.9058 7.11016 16.9058 5.99487C16.9057 3.2901 14.705 1.08936 12.0003 1.08936C9.29515 1.08936 7.09441 3.2901 7.09441 5.99487C7.09441 7.11012 7.46912 8.1388 8.0982 8.96355C7.84026 8.92187 7.57563 8.89868 7.3061 8.89868C4.60065 8.89868 2.3999 11.0998 2.3999 13.8042C2.3999 16.5097 4.60065 18.7097 7.3061 18.7097C8.81776 18.7097 10.1714 18.0217 11.0718 16.9425C10.9176 19.0994 10.5804 21.1571 9.94354 22.911H14.0562C13.4197 21.1571 13.0822 19.0994 12.928 16.9425C13.8284 18.0217 15.182 18.7097 16.694 18.7097C19.3992 18.7097 21.5999 16.5096 21.5999 13.8042C21.5999 11.0998 19.3991 8.89868 16.694 8.89868Z"
          fill="var(--neutralWhite)"
        />
      </svg>
    );
  },
  Globe: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clip-path="url(#clip0_1042_30010)">
          <path
            d="M2.2388 13.0369L3.82896 12.119C3.91509 12.0692 4.01617 12.052 4.11392 12.0703L7.24267 12.6558C7.4998 12.704 7.73715 12.506 7.73599 12.2444L7.7238 9.50306C7.72347 9.42858 7.74311 9.35537 7.78068 9.29105L9.35962 6.58786C9.44179 6.44718 9.43443 6.2715 9.34077 6.13818L6.68227 2.35409M15.8334 4.04856C11.25 6.24938 13.7499 9.16605 14.5834 9.58272C16.1476 10.3647 18.3229 10.416 18.3229 10.416C18.3297 10.278 18.3332 10.1391 18.3332 9.99935C18.3332 5.39698 14.6022 1.66602 9.99984 1.66602C5.39746 1.66602 1.6665 5.39698 1.6665 9.99935C1.6665 14.6017 5.39746 18.3327 9.99984 18.3327C10.1396 18.3327 10.2785 18.3292 10.4165 18.3224M13.9647 18.2825L11.3257 11.3252L18.283 13.9642L15.1979 15.1974L13.9647 18.2825Z"
            stroke="#575757"
            stroke-width="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1042_30010">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
  ImageUserPlus: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M16.3332 6.66602V1.66602M13.8332 4.16602H18.8332M18.8332 9.99935V14.3327C18.8332 15.7328 18.8332 16.4329 18.5607 16.9677C18.321 17.4381 17.9386 17.8205 17.4681 18.0602C16.9334 18.3327 16.2333 18.3327 14.8332 18.3327H6.1665C4.76637 18.3327 4.06631 18.3327 3.53153 18.0602C3.06112 17.8205 2.67867 17.4381 2.43899 16.9677C2.1665 16.4329 2.1665 15.7328 2.1665 14.3327V5.66602C2.1665 4.26588 2.1665 3.56582 2.43899 3.03104C2.67867 2.56063 3.06112 2.17818 3.53153 1.9385C4.06631 1.66602 4.76637 1.66602 6.1665 1.66602H10.4998M2.28795 16.6046C2.67891 15.1982 3.96883 14.166 5.49984 14.166H11.3332C12.1076 14.166 12.4948 14.166 12.8168 14.2301C14.1391 14.4931 15.1728 15.5267 15.4358 16.849C15.4998 17.171 15.4998 17.5583 15.4998 18.3327M12.1665 7.91602C12.1665 9.75697 10.6741 11.2493 8.83317 11.2493C6.99222 11.2493 5.49984 9.75697 5.49984 7.91602C5.49984 6.07507 6.99222 4.58268 8.83317 4.58268C10.6741 4.58268 12.1665 6.07507 12.1665 7.91602Z"
          stroke="#232323"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  FilePlus: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M16.6666 8.74935V5.66602C16.6666 4.26588 16.6666 3.56582 16.3941 3.03104C16.1544 2.56063 15.772 2.17818 15.3016 1.9385C14.7668 1.66602 14.0667 1.66602 12.6666 1.66602H7.33325C5.93312 1.66602 5.23306 1.66602 4.69828 1.9385C4.22787 2.17818 3.84542 2.56063 3.60574 3.03104C3.33325 3.56582 3.33325 4.26588 3.33325 5.66602V14.3327C3.33325 15.7328 3.33325 16.4329 3.60574 16.9677C3.84542 17.4381 4.22787 17.8205 4.69828 18.0602C5.23306 18.3327 5.93312 18.3327 7.33325 18.3327H9.99992M14.9999 17.4993V12.4993M12.4999 14.9993H17.4999"
          stroke="#232323"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  Trash: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5"
          stroke="#929292"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  Download: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M6.66699 10.0008L10.0003 13.3342M10.0003 13.3342L13.3337 10.0008M10.0003 13.3342V5.66749C10.0003 4.50857 10.0003 3.92911 9.54156 3.28032C9.23675 2.84926 8.35914 2.31722 7.83597 2.24634C7.04857 2.13966 6.74955 2.29564 6.15152 2.60761C3.48644 3.99785 1.66699 6.78686 1.66699 10.0008C1.66699 14.6032 5.39795 18.3342 10.0003 18.3342C14.6027 18.3342 18.3337 14.6032 18.3337 10.0008C18.3337 6.91631 16.6578 4.22322 14.167 2.78234"
          stroke="#929292"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  EmailAddress: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.66602 5.83333L8.47012 10.5962C9.02109 10.9819 9.29658 11.1747 9.59624 11.2494C9.86093 11.3154 10.1378 11.3154 10.4025 11.2494C10.7021 11.1747 10.9776 10.9819 11.5286 10.5962L18.3327 5.83333M5.66602 16.6667H14.3327C15.7328 16.6667 16.4329 16.6667 16.9677 16.3942C17.4381 16.1545 17.8205 15.772 18.0602 15.3016C18.3327 14.7669 18.3327 14.0668 18.3327 12.6667V7.33333C18.3327 5.9332 18.3327 5.23313 18.0602 4.69835C17.8205 4.22795 17.4381 3.8455 16.9677 3.60581C16.4329 3.33333 15.7328 3.33333 14.3327 3.33333H5.66602C4.26588 3.33333 3.56582 3.33333 3.03104 3.60581C2.56063 3.8455 2.17818 4.22795 1.9385 4.69835C1.66602 5.23313 1.66602 5.9332 1.66602 7.33333V12.6667C1.66602 14.0668 1.66602 14.7669 1.9385 15.3016C2.17818 15.772 2.56063 16.1545 3.03104 16.3942C3.56582 16.6667 4.26588 16.6667 5.66602 16.6667Z"
          stroke="#575757"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
  PasswordLock: (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.1673 8.33333V6.66667C14.1673 4.36548 12.3018 2.5 10.0007 2.5C7.69946 2.5 5.83398 4.36548 5.83398 6.66667V8.33333M10.0007 12.0833V13.75M7.33398 17.5H12.6673C14.0674 17.5 14.7675 17.5 15.3023 17.2275C15.7727 16.9878 16.1552 16.6054 16.3948 16.135C16.6673 15.6002 16.6673 14.9001 16.6673 13.5V12.3333C16.6673 10.9332 16.6673 10.2331 16.3948 9.69836C16.1552 9.22795 15.7727 8.8455 15.3023 8.60582C14.7675 8.33333 14.0674 8.33333 12.6673 8.33333H7.33398C5.93385 8.33333 5.23379 8.33333 4.69901 8.60582C4.2286 8.8455 3.84615 9.22795 3.60647 9.69836C3.33398 10.2331 3.33398 10.9332 3.33398 12.3333V13.5C3.33398 14.9001 3.33398 15.6002 3.60647 16.135C3.84615 16.6054 4.2286 16.9878 4.69901 17.2275C5.23379 17.5 5.93385 17.5 7.33398 17.5Z"
          stroke="#575757"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
};
